import React from 'react';

import { Container, ContainerProps, Image } from '@lglp/components';
import { Footer } from '@lglp/prismic-client';

import { getSingleTypeDocument } from '../../../actions/prismic';
import loading, { withThunk } from '../../../helpers/loading';
import { useSingleType } from '../../../hooks';
import { SSRComponent } from '../../../types/component';
import { DocumentType } from '../../../types/document';
import { LinkedComponent } from '../../LinkedComponent';
import { ScrollUp } from '../ScrollUp';
import styles from './Footer.module.scss';
import { FooterContents } from './FooterContents';
import { FooterLinks } from './FooterLinks';
import { FooterSocial } from './FooterSocial';

export const FooterComponent: SSRComponent<FooterProps> = ({
  className,
  ...rest
}) => {
  const { data } = useSingleType<Footer>(DocumentType.FOOTER);
  const { logo, image, imageLink, contents, menu, socialNetworks } = data || {};
  return (
    <Container
      as="footer"
      role="contentinfo"
      className={[className, styles.container]}
      {...rest}
    >
      <Container className={styles.footer}>
        <Image src={logo?.src} alt={logo?.alt} className={styles.logo} />
        <FooterSocial
          title={socialNetworks?.title}
          socialLinks={socialNetworks?.list}
          className={styles.socialNetworks}
        />
        <FooterContents contents={contents} className={styles.contents} />
        <Container className={styles.image}>
          <LinkedComponent
            link={imageLink}
            className={!imageLink && styles.notALink}
          >
            <Image src={image?.src} alt={image?.alt} className={styles.img} />
          </LinkedComponent>
        </Container>
        <Container className={styles.menu}>
          <FooterLinks menu={menu} />
        </Container>
      </Container>
      <ScrollUp />
    </Container>
  );
};

FooterComponent.getInitialProps = async (serverData: any): Promise<any> =>
  loading(serverData, withThunk(getSingleTypeDocument(DocumentType.FOOTER)));

type FooterProps = ContainerProps;
